'use client'

import { CollectionContainer } from '@/components/common/collection/collection-container'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { useIsMobileClient } from '@/hooks/common/use-device-type'
import {
  RunningFeatureCard,
  RunningFeatureCardData,
} from './running-feature-card'

interface Props {
  items: RunningFeatureCardData[]
}

export const RunningFeatureGrid = ({ items }: Props) => {
  const isMobile = useIsMobileClient()

  return (
    <CollectionContainer>
      {isMobile ? (
        <Carousel
          opts={{ align: 'start', loop: false, containScroll: false }}
          className='w-full'
        >
          <CarouselContent className='-ml-4'>
            {items.map((item, index) => (
              <CarouselItem key={index} className='basis-[80%] pl-4'>
                <RunningFeatureCard {...item} />
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious
            className='absolute -left-3 top-1/2 h-7 w-7 -translate-y-1/2'
            variant='black'
            hideIfStart
          />
          <CarouselNext
            className='absolute -right-3 top-1/2 h-7 w-7 -translate-y-1/2'
            variant='black'
            hideIfEnd
          />
        </Carousel>
      ) : (
        <div className='grid grid-cols-4 gap-5'>
          {items.map((item, index) => (
            <RunningFeatureCard key={index} {...item} />
          ))}
        </div>
      )}
    </CollectionContainer>
  )
}
